"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.8 400.8",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("circle", {
        fill: "currentColor",
        cx: "142.4",
        cy: "88",
        r: "34.5"
      }), (0, jsx_runtime_1.jsx)("ellipse", {
        transform: "matrix(0.8507 -0.5257 0.5257 0.8507 -1.7165 153.0474)",
        fill: "currentColor",
        cx: "268.5",
        cy: "79.5",
        rx: "35.6",
        ry: "35.6"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M304.9,121.2h-72.5c-11,0-19.9,8.9-19.9,19.9v12.5c16.5,3.9,28.9,18.8,28.9,36.5c0,9.4-3.5,18.1-9.3,24.7\n\t\tc7.9,2.7,13.5,10.2,13.5,19V286c0,7.7-4.4,14.4-10.8,17.8v31.3c0,11,8.9,19.9,19.9,19.9h25.7c11,0,19.9-8.9,19.9-19.9v-83.6\n\t\tc0-1.4,1.1-2.6,2.6-2.6h1.9c11,0,19.9-8.9,19.9-19.9v-87.9C324.7,130.1,315.8,121.2,304.9,121.2z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M162,286v-52.2c0-8.8,5.7-16.3,13.5-19c-5.8-6.6-9.3-15.2-9.3-24.7c0-18.3,13.1-33.5,30.4-36.9\n\t\tc-1.4-14-13.2-24.9-27.6-24.9h-51.2c-0.2,0-0.5,0-0.7,0c-0.3,0-0.7,0-1,0.1c-15.4,0.9-27.6,13.5-28,29l-10.8,70.2\n\t\tc-1.6,10.5,5.6,20.3,16.1,22c1.4,0.2,2.3,1.5,2.1,2.8l-5.6,36.9c-0.5,3.5,2.2,6.6,5.7,6.6h14.2v39.8c0,10.6,8.6,19.3,19.3,19.3H154\n\t\tc10.6,0,19.3-8.6,19.3-19.3v-31.6C166.6,300.8,162,293.9,162,286z"
      }), (0, jsx_runtime_1.jsx)("ellipse", {
        transform: "matrix(0.9571 -0.2898 0.2898 0.9571 -46.3795 67.2529)",
        fill: "currentColor",
        cx: "203.9",
        cy: "190.2",
        rx: "27.1",
        ry: "27.1"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M235.3,233.8c0-5.3-4.3-9.7-9.7-9.7h-43.4c-5.3,0-9.7,4.3-9.7,9.7V286c0,5.3,4.3,9.7,9.7,9.7h2.9v49.6\n\t\tc0,5.3,4.3,9.7,9.7,9.7h17.3c5.3,0,9.7-4.3,9.7-9.7v-49.6h3.9c5.3,0,9.7-4.3,9.7-9.7v-52.2H235.3z"
      })]
    })
  });
};

exports.default = Icon;